import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { captureCampaign } from './features/tracking/campaign';
import { readConsent } from './features/tracking/consent';
import './styles/index.css';

/* LA CAMPAÑA SE GUARDA ANTES DE QUE REACT EXISTA, y esa línea de más es todo el
 * arreglo de una carrera real.
 *
 * `RouteTracking` la capturaba en un `useEffect`, o sea DESPUÉS del primer
 * pintado. Entre el pintado y el efecto hay una ventana en la que la página ya
 * responde a los clics pero la campaña todavía no está guardada: quien pulse un
 * enlace interno ahí dentro llega a la ciudad con la barra ya limpia —React
 * Router borró la query— y la campaña se pierde para toda la sesión. Es
 * exactamente el mismo agujero que el del botón de entradas del 12-ago, un
 * escalón más arriba: no fallaba QUIÉN lee el almacén, sino CUÁNDO se llena.
 *
 * Se vio como una prueba intermitente —pasaba sola y caía en la suite entera,
 * con la máquina cargada— y eso es justo lo que es una carrera: el mismo código,
 * dos resultados, según llegue antes el efecto o el clic. Con la captura aquí no
 * hay ventana: cuando el primer píxel se pinta, la campaña lleva guardada desde
 * antes de que existiera el árbol.
 *
 * El efecto de `RouteTracking` SE QUEDA, y no es duplicado: atiende los cambios
 * de ruta posteriores y la subida a consentimiento concedido (los `fbclid` y
 * demás identificadores de clic sólo entran con el sí). Repetir no cuesta nada:
 * `captureCampaign` no pisa lo ya guardado. */
captureCampaign(window.location.search, readConsent() === 'granted');

const container = document.getElementById('root');
if (!container) {
  throw new Error('No existe #root en index.html: la app no puede montar.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
